module.exports = __webpack_public_path__ + "static/media/ic_info_outline_black_24px.50039456.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/ic_info_outline_black_24px.svg
// module id = 792
// module chunks = 0